<template>
  <div>
    <BaseNav />
    <div ref="left" class="pt-16 md:pt-24 w-full md:w-1/2 p-4 md:p-8 pb-24">
      <slot name="left"></slot>
    </div>
    <div ref="right" class="hidden md:block mt-19 w-1/2 fixed top-0 right-0 border-black border-l h-full overflow-y-scroll scrolling-touch"
      :class="{ 'mobile-show': this.$route.params.slug }">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'splitscreen',
  computed: {
    ...mapState['events']
  }
}
</script>

<style lang="stylus">
  .scrolling-touch
    -webkit-overflow-scrolling: touch

  @media (max-width: 768px)
    .mobile-show
      @apply bg-white
      display block !important
      left: 1em !important
      width: calc(100vw - 1em) !important
</style>
